import { gql } from '@apollo/client';

export const SET_PROMOTIONAL_SHEET = gql`
    mutation SetPromotionalSheet($promotionalSheetInput: PromotionalSheetInput!) {
        setPromotionalSheet(promotionalSheetInput: $promotionalSheetInput)
    }
`;
